export const BetaBanner = () => {
  return (
    <div className="phase-banner page">
        <div className="container-fluid">
            <p>
                <strong className="phase-tag">BETA</strong>
                <span>This is a new service — your advice will help us to improve it. Please send an email to <a href="mailto:ascformfeedback@leeds.gov.uk?subject=Leeds ASC Referral form feedback">ascformfeedback@leeds.gov.uk</a> with any feedback you have</span>
            </p>
        </div>
    </div>
  )
};